import React from "react";
import { Grid } from "semantic-ui-react";
import { Panel } from "components/panel";
import { InvalidUser } from "./invalid-user";
import SuccessDigitize from "./success-digitize";
import SearchInputNew from "components/search-input-new";
import { CSSTransition } from "react-transition-group";
import PopupMessage from "components/popup-message";
import { EntitiesList } from "components/entities-list";
import { DigitizeTicketForm } from "./digitize-ticket-form";
import { formatUserList } from "../components/user-list-item";
import { DigitizeConfirmation } from "./digitize-confirmation";

const MposTicketsDigitizeView = ({
  viewType,
  role,
  category,
  viewState,
  searchParam,
  users,
  commerce,
  showResponsePanel,
  selectedUser,
  ticketPaid,
  premiumObj,
  showForm,
  newTicketReference,
  newTicketDate,
  newTicketHour,
  newTicketMinute,
  generatedTicket,
  showGeneratedTicket,
  buildingName,
  digitizedBy,
  popupMessages,
  popupMessagesType,
  showPopup,
  location,
  handleSearchInputChange,
  handleUserSelection,
  removeSelectedUser,
  handleTicketReference,
  handleTicketDate,
  handleTicketHour,
  handleTicketMinute,
  handleSearchUser,
  toggleDigitizeConfirmation,
  digitizeTicket,
  resetView,
  closePopup,
}) => {
  return (
    <Grid padded>
      {!(
        viewState === "ticket_digitize_confirmation" ||
        viewState === "ticket_digitize_loading"
      ) && (
        // If not on confirmation process, show popup
        <PopupMessage
          messageType={popupMessagesType}
          showPopup={showPopup}
          messages={popupMessages}
          closePopup={closePopup}
        />
      )}

      {(viewState === "ticket_digitize_confirmation" ||
        viewState === "ticket_digitize_loading") && (
        // If view IS on confirmation process, show confirmation popup
        <PopupMessage
          messageType={popupMessagesType}
          showPopup={showPopup}
          messages={popupMessages}
          closePopup={toggleDigitizeConfirmation}
        >
          <DigitizeConfirmation
            viewState={viewState}
            selectedUser={selectedUser}
            newTicketReference={newTicketReference}
            newTicketDate={newTicketDate}
            newTicketHour={newTicketHour}
            newTicketMinute={newTicketMinute}
            digitizeTicket={digitizeTicket}
            cancel={toggleDigitizeConfirmation}
          />
        </PopupMessage>
      )}

      <Grid.Column width={16}>
        {(viewState === "user_search" ||
          viewState === "user_search_loading" ||
          viewState === "user_search_done") && [
          <SearchInputNew
            key="search-input"
            placeholder="Buscar Usuario"
            searchParam={searchParam}
            handleChange={handleSearchInputChange}
            handleSearch={handleSearchUser}
          />,
          <EntitiesList
            key="users-list"
            height="calc(100vh - 9rem)"
            viewState={viewState}
            entities={users}
            formattingFunction={formatUserList}
            selectionHandler={handleUserSelection}
          />,
        ]}

        <CSSTransition
          in={showResponsePanel}
          mountOnEnter
          unmountOnExit
          timeout={350}
          appear={true}
          classNames="panel"
        >
          <Panel
            className={
              (viewState === "user_selection_loading" ||
                viewState === "ticket_digitize_confirmation" ||
                viewState === "ticket_digitize_loading" ||
                viewState === "ticket_digitize_done") &&
              "inactive"
            }
          >
            {(viewState === "user_selection_loading" ||
              viewState === "ticket_digitize_loading") && (
              <div className="ui loader active"></div>
            )}

            {viewState === "user_selection" && (
              <InvalidUser
                viewType={viewType}
                viewState={viewState}
                username={selectedUser.username}
                removeSelectedUser={removeSelectedUser}
              />
            )}

            {(viewState === "user_selection_done" ||
              viewState === "ticket_digitize_confirmation" ||
              viewState === "ticket_digitize_loading" ||
              viewState === "ticket_digitize_done") && (
              <DigitizeTicketForm
                viewType={viewType}
                viewState={viewState}
                showForm={showForm}
                selectedUser={selectedUser}
                newTicketReference={newTicketReference}
                newTicketDate={newTicketDate}
                newTicketHour={newTicketHour}
                newTicketMinute={newTicketMinute}
                buildingName={buildingName}
                // handlers
                handleTicketReference={handleTicketReference}
                handleTicketDate={handleTicketDate}
                handleTicketHour={handleTicketHour}
                handleTicketMinute={handleTicketMinute}
                removeSelectedUser={removeSelectedUser}
                toggleDigitizeConfirmation={toggleDigitizeConfirmation}
              />
            )}
          </Panel>
        </CSSTransition>

        <CSSTransition
          in={showGeneratedTicket || viewState === "user_selection"}
          mountOnEnter
          unmountOnExit
          timeout={350}
          appear={true}
          classNames="panel"
        >
          <Panel className="">
            {(viewState === "ticket_digitize_done" ||
              viewState === "user_selection") && (
              <SuccessDigitize
                viewState={viewState}
                viewType={viewType}
                username={selectedUser.username}
                role={role}
                category={category}
                commerce={commerce}
                ticketPaid={ticketPaid}
                premiumObj={premiumObj}
                generatedTicket={generatedTicket}
                digitizedBy={digitizedBy}
                resetView={resetView}
              />
            )}
          </Panel>
        </CSSTransition>
      </Grid.Column>
    </Grid>
  );
};

export default MposTicketsDigitizeView;
